import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import { AuthContext } from "context";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, portalSettingsLoading } = useContext(AuthContext);

  if (isLoading || portalSettingsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
